import _axios from "../../libs/axios";
import moment from "moment"
import { NotificationManager } from "../../components/common/react-notifications";
export default (context) => {
  return {
    config: {
      pageSize: 40,
      list: false
    },

    actions: {
      create: {
        reloadGrid: true
      },
      edit: {
        reloadGrid: true
      },
      delete: true,
      print: false,
      export: true,
      search: true,
      import: {
        templateFile: "TimetablesImport.xlsx",
        moduleName: "admActivityParts"
      }
    },

    extras: {
      itemsInRowsTable: [
        {
          icon: 'simple-icon-calculator',
          name: 'Calcular orden mérito',
          onClick: (rowData, ctx) => {
            context.props.setLoader(true);
            _axios.post(`admPeriod/action/${rowData.ID}/calcrank`, {})
              .then(r => {
                context.props.setLoader(false);
                NotificationManager[r.status >= 0 ? 'success' : 'error'](
                  r.msg,
                  r.status >= 0 ? 'Éxito' : 'Error',
                  5000,
                  null,
                  null,
                  'outline'
                );
              })
          }
        }
      ]
    },

    filter: {
      fields: [],
      buttons: [
        {
          label: 'Aplicar filtro',
          renderIf: (ctx) => false,
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0 && r.data.activityId !== null && r.data.activityId !== undefined) {
          if (typeof r.data.activityId === "object") {
            r.data.activityId = {
              value: r.data.activityId.value ?? r.data.activityId.ID,
              label: r.data.activityId.label ?? r.data.activityId.name
            }
          } else {
            r.data.activityId = {
              value: r.data.activityId,
              label: r.data.activityName || r.data.activity || r.data.activityId
            }
          }
        }
        return r
      },
      setValuesBeforePost: (v) => {
        v.showGradesOnlineMsg = v.showGradesOnlineMsg?? ""
        v.showGradesPDFMsg = moment(v.showGradesFrom) > moment() ? v.showGradesPDFMsg : ""
        return v
      },
      fields: [
        {
          col: 12,
          name: "ID",
          value: null,
          type: "number",
          label: "Código",
          rules: 'required|numeric|min:202200,num|size:6',
          rulesMessages: {messages: {min: 'El :attribute debe ser un número mayor o igual a: :min', size: 'El :attribute debe de ser un número de solo :size dígitos'}},
          opts: {
            style: 'float-label'
          },
          renderIf: () => { return context.state.idItemSelected ? false : true }
        },
        {
          col: 12,
          name: "name",
          value: null,
          type: "text",
          label: "Nombre",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 4,
          name: "from",
          value: null,
          type: "date",
          label: "main.from",
          rules: 'required',
          opts: {
            style: 'float-label',
            selectsStart: true,
            startDate: (ctx) => ctx.state.from ? moment(ctx.state.from) : null,
            endDate: (ctx) => ctx.state.to ? moment(ctx.state.to) : null
          },
        },
        {
          col: 4,
          name: "to",
          value: null,
          type: "date",
          label: "main.to",
          rules: 'required',
          opts: {
            style: 'float-label',
            selectsEnd: true,
            startDate: (ctx) => moment(ctx.state.from),
            endDate: (ctx) => moment(ctx.state.to),
            minDate: (ctx) => moment(ctx.state.from)
          },
          renderIf: ctx => ctx.state.from
        },
        {
          col: 4,
          name: "activityId",
          value: null,
          type: "select",
          label: "Academic Year",
          opts: {
            style: 'float-label',
            isClearable: true,
            path: () => { return "/admActivity/get?type=ayr" }
          }
        },
        {
          col: 4,
          name: "active",
          value: true,
          type: "switch",
          label: "Periodo activo",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 4,
          name: "closed",
          value: false,
          type: "switch",
          label: "Periodo cerrado",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 4,
          name: "current",
          value: false,
          type: "switch",
          label: "Periodo actual",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "showGradesFrom",
          value: null,
          type: "datetime",
          label: "Mostrar libreta a partir de:",
          rules: 'required',
          opts: {
            style: 'float-label',
            isClearable: true,
            dateFormat: 'YYYY/MM/DD HH:mm'
          }
        },
        {
          col: 6,
          name: "showGradesOnline",
          value: false,
          type: "switch",
          label: "Mostrar notas en línea",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "showGradesOnlineMsg",
          value: null,
          type: "textarea",
          label: "Mensaje a mostrar - notas en línea",
          placeholder: "Escribe un mensaje para que se muestre en la app móvil cuando se desactive la visualización de las notas en línea.",
          maxLength: "255",
          parent: "showGradesOnline",
          opts: {
            style: 'float-label'
          },
          renderIf: (ctx) => ctx.state.showGradesOnline === false
        },
        {
          col: 12,
          name: "showGradesPDFMsg",
          value: null,
          type: "textarea",
          label: "Mensaje a mostrar - notas en PDF",
          placeholder: "Escribe un mensaje para que se muestre en la app móvil cuando la libreta de notas aún no este disponible para la descarga.",
          maxLength: "255",
          opts: {
            style: 'float-label'
          },
          renderIf: (ctx) => moment(ctx.state.showGradesFrom) > moment()
        },
        {
          col:6,
          name:"confirmVisible",
          value:false,
          type: "switch",
          label: "",
          renderIf:()=>false
        },
        {
          col: 12,
          name: "confirm",
          value: "",
          type: "text",
          label: "Se clonarán todos los cursos. Para confirmar la clonación escribir aquí el código del nuevo periodo",
          rules: 'required|numeric|min:6|max:6',
          opts: {
            style: 'float-label'
          },
          renderIf: (ctx) => ctx.state.confirmVisible
        },
        {
          col: 12,
          name: "clone",
          value: null,
          type: "button",
          label: "Clonar este periodo",
          opts: {
            kind: 'danger'
          },
          renderIf: (ctx) => { if(!ctx.state.showClone)ctx.state.showClone = ctx.state.ID?1:-1; return ctx.state.showClone===1; },
          onClick: (ctx) => {
            ctx.setState({confirmVisible:true})
            if(ctx.state.confirm?.length===6) {
              context.props.setLoader(true)
              _axios.post('admSubject/duplicate?newId='+ctx.state.confirm+'&periodId=' + ctx.state.ID, { })
                .then(r => {
                  if(r.status===0){
                    context.props.setLoader(false)
                    context.setState(
                      prevState => ({
                        idItemSelected: r.data.periodId,
                        form: {
                          ...prevState.form,
                          ID: r.data.periodId
                        }
                      }),
                      () => {
                        context.edit();
                      }
                    );
                    // context.toggle()
                    // context.getData()
                  }
                  NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                  
              })
            }
          }
        }
      ],
      detailGrid: () => {
        return {
          module: 'admSuperSection',
          parentIdField: 'ID',
          embeded: (eContext) => {
            return {
              config: {
                customTitle: "Excepción a la configuración del periodo",
                pageSize: 40,
                customPathGet: 'admPeriod/supersections',
                remap: (r) => {
                  r.data.Results.map(e => e.showGradesPDF = moment(e.showGradesFrom) <= moment())
                  return r
                }    
              },
          
              actions: {
                create: false,
                edit: {
                  reloadGrid: true
                },
                delete: false,
                print: false,
                export: false      
              },
          
              filter: {
                fields: [
                  {
                    name: "showGradesDefault",
                    value: false,
                    type: "hidden"
                  },
                  {
                    name: "btnCreate",
                    value: null,
                    type: "button",
                    label: "Crear excepción",
                    opts: {
                      wrapperClassName: 'mb-0 d-flex justify-content-end',
                      colClassName: "offset-sm-9"
                    },
                    onClick: (ctx) => {
                      ctx.setState({showGradesDefault: true}, () => {
                        eContext.actionsInColumns('simple-icon-plus')
                        process.nextTick(() => { eContext.resetDataTable() })
                      }) 
                    },
                    renderIf: (ctx) => ctx.state.showGradesDefault === false || ctx.state.showGradesDefault === null
                  },
                  {
                    name: "btnCancel",
                    value: null,
                    type: "button",
                    label: "",
                    opts: {
                      icon: "simple-icon-arrow-left",
                      wrapperClassName: 'mb-0 d-flex justify-content-end',
                      colClassName: "offset-sm-9"
                    },
                    onClick: (ctx) => {
                      ctx.setState({showGradesDefault: false}, () => {
                        eContext.actionsInColumns('simple-icon-pencil')
                        process.nextTick(() => { eContext.resetDataTable() })
                      }) 
                    },
                    renderIf: (ctx) => ctx.state.showGradesDefault === true
                  }
                ]
              },
          
              form: {
                afterEdit: () => {
                  let formFilter = eContext.state.formFilter
                  formFilter.showGradesDefault = false
                  eContext.setState({formFilter: formFilter}, () => {
                    eContext.actionsInColumns('simple-icon-pencil')
                  }) 
                },
                remapOne: (r) => {
                  r.data.showGradesFrom = r.data.showGradesDefault === false ? r.data.showGradesFrom : moment().format('YYYY-MM-DD HH:mm:ss')
                  r.data.showGradesDefault = !r.data.showGradesDefault
                  return r
                },
                setValuesBeforePost: (v) => {
                  v.showGradesDefault = !v.showGradesDefault
                  v.showGradesOnlineMsg = v.showGradesOnlineMsg?? ""
                  v.showGradesPDFMsg = moment(v.showGradesFrom) > moment() ? v.showGradesPDFMsg : ""
                  return v
                },
                fields: [
                  {
                    name: "owner",
                    type: "hidden",
                  },
                  {
                    col: 6,
                    name: "showGradesDefault",
                    value: null,
                    type: "switch",
                    label: "Hablitar excepción",
                  },
                  {
                    col: 6,
                    name: "name",
                    value: "",
                    type: "text",
                    label: "Grado",
                    opts: {
                      style: 'float-label'
                    },
                    disabled: true
                  },
                  {
                    col: 6,
                    name: "showGradesFrom",
                    value: null,
                    type: "datetime",
                    label: "Mostrar libreta a partir de:",
                    rules: 'required',
                    opts: {
                      style: 'float-label',
                      isClearable: true,
                      dateFormat: 'YYYY/MM/DD HH:mm'
                    },
                    renderIf: ctx => ctx.state.showGradesDefault
                  },
                  {
                    col: 6,
                    name: "showGradesOnline",
                    value: null,
                    type: "switch",
                    label: "Mostar notas en linea",
                    renderIf: ctx => ctx.state.showGradesDefault
                  },
                  {
                    col: 12,
                    name: "showGradesOnlineMsg",
                    value: null,
                    type: "textarea",
                    label: "Mensaje a mostrar - notas en línea",
                    parent: "showGradesOnline",
                    placeholder: "Escribe un mensaje para que se muestre en la app móvil cuando se desactive la visualización de las notas en línea.",
                    maxLength: "255",
                    opts: {
                      style: 'float-label'
                    },
                    renderIf: ctx => !ctx.state.showGradesOnline && ctx.state.showGradesDefault
                  },
                  {
                    col: 12,
                    name: "showGradesPDFMsg",
                    value: null,
                    type: "textarea",
                    label: "Mensaje a mostrar - notas en PDF",
                    placeholder: "Escribe un mensaje para que se muestre en la app móvil cuando la libreta de notas aún no este disponible para la descarga.",
                    maxLength: "255",
                    opts: {
                      style: 'float-label'
                    },
                    renderIf: ctx => ctx.state.showGradesDefault && moment(ctx.state.showGradesFrom) > moment()
                  }
                ]      
              },
          
              columns: [
                {
                  Header: "Grado",
                  accessor: "name",
  
                },
                {
                  Header: "Mostar a partir de",
                  accessor: "showGradesFrom",
                  isDate: true
                },
                {
                  Header: "Libreta en línea",
                  accessor: "showGradesPDF",
                  isBool: true
                },
                {
                  Header: "Mensaje a mostrar - Notas en linea",
                  accessor: "showGradesOnlineMsg"
                },
                {
                  Header: "Mensaje a mostrar - Notas en PDF",
                  accessor: "showGradesPDFMsg"
                }
              ]
            }
          },
          renderIf: () => context.state.idItemSelected && context.state.form?.current
        }
      }
    },

    columns: [
      {
        Header: "ID",
        accessor: "ID"
      },
      {
        Header: "Nombre",
        accessor: "name",
      },
      {
        Header: "Desde",
        accessor: "from",
        isDate: true
      },
      {
        Header: "Hasta",
        accessor: "to",
        isDate: true
      },
      {
        Header: "Activo",
        accessor: "active",
        isBool: true
      },
      {
        Header: "Actual",
        accessor: "current",
        isBool: true
      }
    ]
  }
}